export default {
      id: "Icon--minus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--minus",
      toString: function () {
        return this.url;
      }
    }